import script from "./ValidateSkillsWeb.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidateSkillsWeb.vue?vue&type=script&setup=true&lang=js"

import "./ValidateSkillsWeb.vue?vue&type=style&index=0&id=777d6110&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777d6110"]])

export default __exports__